import { cn } from "@/lib/utils";
import { Link as TanstackLink, useLocation } from "@tanstack/react-router";
import type { PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  href: {
    pathname: string;
    query?: Record<string, string | string[] | undefined>;
  };
  className?: string;
  target?: string;
  rel?: string;
  activeClassName?: string;
  prefetch?: boolean;
  preventSameRouteNavigation?: boolean;
}>;

export const Link = ({
  href,
  children,
  className,
  activeClassName,
  target,
  prefetch,
  rel,
  preventSameRouteNavigation = true,
}: Props) => {
  const location = useLocation();
  const pathname = location.pathname;

  const splittedPathname = pathname.split("/");
  const isActive = splittedPathname.includes(href.pathname);

  const toPath = href.pathname.startsWith("/")
    ? href.pathname
    : `../${href.pathname}`;

  const handleClick = (e: React.MouseEvent) => {
    if (preventSameRouteNavigation && isActive) {
      e.preventDefault();
      return false;
    }
  };

  return (
    <TanstackLink
      to={toPath}
      search={href.query}
      target={target}
      rel={rel}
      className={cn(
        className,
        isActive && "font-bold text-primary",
        isActive && activeClassName,
      )}
      onClick={handleClick}
      preload={prefetch ? "intent" : false}
    >
      {children}
    </TanstackLink>
  );
};
